import request from "@/http/axios";

export function login(token, billingCode, prod) {
  return request({
    url: "/telmonitor/conf/login",
    method: "POST",
    data: {
      token,
      billingCode,
      prod
    }
  });
}
